import React, { Fragment, useState } from 'react';
import { makeStyles, Theme, useTheme } from '@material-ui/core/styles';
import { colors, Typography, Link, Button } from '@material-ui/core';
import { useDropzone } from 'react-dropzone';
import clsx from 'clsx';
import { Alert, AlertTitle } from '@material-ui/lab';


interface IDropzone {
    onDropCallback: (acceptedFiles: any) => any
    isMultiple: boolean,
    accept?: string[] | string
    style?: React.CSSProperties
}

let useStyles = makeStyles((theme: Theme) => ({
    dropzone: {
        border: `2px dashed #560604`,
        padding: theme.spacing(1),
        outline: 'none',
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
        alignItems: 'center',
        marginTop: theme.spacing(1),
        '&:hover': {
            backgroundColor: colors.grey[50],
            opacity: 0.5,
            cursor: 'pointer'
        }
    },
    dragActive: {
        backgroundColor: colors.grey[50],
        opacity: 0.5
    }
}));

interface IFileError {
    filename: string
    errorMessage: string
}

let Dropzone = (props: IDropzone) => {
    let theme = useTheme();
    let classes = useStyles(theme);

    let [errorMessages, setErrorMessages] = useState<IFileError[]>([]);

    let { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop: props.onDropCallback,
        multiple: props.isMultiple,
        accept: props.accept,
        minSize: 1, // 1 byte
        maxSize: 200000000, // 200Mb in bytes
        onDropAccepted: (files) => {
            files.forEach(file => {
                let idx = errorMessages.findIndex(x => x.filename === file.name);

                if (idx !== -1)
                    errorMessages.splice(idx, 1)
            })

            setErrorMessages([...errorMessages])
        },
        onDropRejected: (files) => {
            files.forEach(file => {
                let idx = errorMessages.findIndex(x => x.filename === file.file.name);

                let obj: IFileError = {
                    filename: file.file.name,
                    errorMessage: file.errors.map(err => err.message).join(', ')
                }

                if (idx === -1)
                    errorMessages.push(obj)
                else
                    errorMessages.splice(idx, 1, obj)
            })

            setErrorMessages([...errorMessages])
        }
    });


    return (
        <>
            <div
                style={props.style}
                className={
                    clsx({
                        [classes.dropzone]: true,
                        [classes.dragActive]: isDragActive
                    })
                }
                {...getRootProps()}
            >
                <input {...getInputProps()} />

                <Typography
                    color="textSecondary"
                    variant="body1"
                >
                    Drag files here or&nbsp;<Link underline="always">click</Link>&nbsp;to search one
                </Typography>

            </div>
            {errorMessages.length > 0 &&
                <Alert
                    style={{ marginTop: 20 }}
                    severity="error"
                    onClose={() => setErrorMessages([])}
                >
                    {props.accept &&
                        <AlertTitle>
                            {Array.isArray(props.accept)
                                ? `Only these files${props.accept.map(accept => ` ${accept}`)} are accepted.`
                                : `Only this file ${props.accept} is accepted`}
                        </AlertTitle>
                    }
                    {!props.accept && <AlertTitle>Unable to upload files</AlertTitle>}
                    {errorMessages.map(error =>
                        <Fragment key={error.filename}>
                            {error.filename}: {error.errorMessage}<br />
                        </Fragment>
                    )}
                </Alert>
            }
        </>
    )
}

export default Dropzone;